import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { workflowRoutingModule } from './workflow-routing.module';
import { MatTabsModule } from '@angular/material/tabs';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatCardModule } from '@angular/material/card';
import { WorkflowComponent } from './workflow.component';
import { WorkflowDashboardComponent } from './workflow-dashboard/workflow-dashboard.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgGanttEditorModule } from 'ng-gantt';
import { SharedModule } from 'src/app/middleware/shared/shared.module';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from 'src/app/middleware/authentication/interceptor/auth-interceptor';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ClipboardModule } from '@angular/cdk/clipboard';

@NgModule({
  declarations: [WorkflowDashboardComponent, WorkflowComponent],
  imports: [
    CommonModule,
    workflowRoutingModule,
    MatTabsModule,
    FlexLayoutModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatRadioModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatTableModule,
    DragDropModule,
    ScrollingModule,
    MatCardModule,
    MatBadgeModule,
    MatProgressBarModule,
    NgGanttEditorModule,
    NgxMaterialTimepickerModule,
    MatProgressSpinnerModule,
    ClipboardModule,
    SharedModule
  ],
  providers: [
    LoaderService,

    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
  ]
})
export class WorkflowModule { }
